import React from 'react';
import PropTypes from 'prop-types';
import { Card, Page } from '../../../components';
import CarrierForm from './CarrierForm';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default function AddCarrier({ history }) {
  const redirectOnSuccess = (carrier) => {
    history.push(`/settings/carriers/${carrier.id}`);
  };
  return (
    <Page
      breadcrumbs={[{ content: 'View Carriers', href: '/settings/carriers' }]}
      title="Add Carrier"
    >
      <Card>
        <Card.Block>
          <CarrierForm successCallback={redirectOnSuccess} />
        </Card.Block>
      </Card>
    </Page>
  );
}

AddCarrier.propTypes = propTypes;
